/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlayerNoteCommand } from '../../models/create-player-note-command';
import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';

export interface ApiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params {
      body?: CreatePlayerNoteCommand
}

export function apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue.PATH = '/api/player-notes';
